import dayjs from 'dayjs';

export function formatRequestPayload(
  alertObj: any,
  Id: any,
  usermode: boolean,
  hasCallLimit: boolean,
  countryInfo: any,
  optionsByAccount?: Record<number, Array<any>>,
) {
  const details = { ...alertObj };

  const personDetails = {
    ...details,
    Person: formatPersonPayload(
      details?.Person,
      Id,
      usermode,
      hasCallLimit,
      countryInfo,
    ),
    PersonId: details?.Person?.Id,
    StartDate: details?.StartDate ? dayjs(details.StartDate).utc().format() : null,
    EndDate: details?.EndDate ? dayjs(details.EndDate).utc().format() : null,
    PersonAlertLimiterSettingValues:
      getPersonAlertLimiterValues(optionsByAccount),
  };
  if (usermode) {
    return {
      ...personDetails,
      EnteredBy: '',
      EnteredDate: new Date().toISOString(),
      Id: 0,
    };
  }
  return { ...personDetails };
}

function formatPersonPayload(
  personDetails: any,
  Id: number,
  usermode: boolean,
  hasCallLimit?: boolean,
  countryInfo?: any,
) {
  const details = { ...personDetails };
  const personAlertDetails = formatAlertDetails(countryInfo, details, usermode);

  //person alert details preferred name
  // const alternativeName =
  //   details?.PersonAlertDetails?.PreferredName !== null &&
  //   details?.PersonAlertDetails?.PreferredName !== undefined &&
  //   details?.PersonAlertDetails?.PreferredName !== ''
  //     ? details?.PersonAlertDetails?.PreferredName
  //     : null;

  const personObj = {
    ...details,
    Birthdate:
      details?.PersonAlertDetails?.Birthdate !== null &&
      details?.PersonAlertDetails?.Birthdate !== undefined &&
      details?.PersonAlertDetails?.Birthdate !== ''
        ? dayjs(details?.PersonAlertDetails?.Birthdate).format('MM/DD/YYYY')
        : null,
    Age:
      details?.PersonAlertDetails?.Age === '' ||
      details?.PersonAlertDetails?.Age == undefined
        ? null
        : details?.PersonAlertDetails?.Age,
    AccountId: Id,
    PersonAlertDetails: {
      ...personAlertDetails,
      // PreferredName: alternativeName,
    },
    PrimaryAddress: personAlertDetails?.PrimaryAddress
      ? { ...personAlertDetails?.PrimaryAddress }
      : null,
    PrimaryPhone: { ...personAlertDetails?.PrimaryPhone },
    SecondaryPhone: { ...personAlertDetails?.SecondaryPhone },
  };

  if (usermode) {
    const entityId = create_UUID();
    return {
      ...personObj,
      Prefix: '',
      Suffix: '',
      EntityId: personObj?.EntityId ? personObj?.EntityId : entityId,
      PersonCallLimit:
        hasCallLimit && hasCallLimit === true
          ? {
              ...details?.PersonCallLimit,
              EntityId: personObj?.EntityId ? personObj?.EntityId : entityId,
            }
          : null,
    };
  }

  return {
    ...personObj,
    PersonCallLimit:
      hasCallLimit && hasCallLimit === true
        ? { ...details?.PersonCallLimit, EntityId: personObj?.EntityId }
        : null,
  };
}

function formatAlertDetails(countryInfo: any, details: any, usermode: boolean) {
  const personAlertObj = { ...details?.PersonAlertDetails };
  const usCountryId = countryInfo?.find(
    (x: any) => x.Abbreviation === 'US',
  )?.Id;

  if (!personAlertObj) {
    return {
      PrimaryPhone: { CountryId: usCountryId, PhoneTypeId: 1, PhoneType: null },
      SecondaryPhone: {
        CountryId: usCountryId,
        PhoneTypeId: 1,
        PhoneType: null,
      },
      PrimaryAddress: null,
      Birthdate: null,
    };
  }
  // if IsAllAlertsExpired is true and in craete mode, we should send the latest values for personalerts from person object
  if (details?.IsAllAlertsExpired && usermode) {
    const objtoReturn = {
      ...personAlertObj,
      PrimaryPhone:
        details.PrimaryPhone !== null && details.PrimaryPhone !== undefined
          ? ensureCountryId(
              { ...details.PrimaryPhone, Id: personAlertObj.PrimaryPhone?.Id },
              usCountryId,
            )
          : null,
      SecondaryPhone:
        details.SecondaryPhone !== null && details.SecondaryPhone !== undefined
          ? ensureCountryId(
              {
                ...details.SecondaryPhone,
                Id: personAlertObj.SecondaryPhone?.Id,
              },
              usCountryId,
            )
          : null,
      PrimaryAddress: details.PrimaryAddress
        ? { ...details.PrimaryAddress, Id: personAlertObj.PrimaryAddress?.Id }
        : null,
      Birthdate:
        details.Birthdate !== '' &&
        details.Birthdate !== undefined &&
        details.Birthdate !== null
          ? dayjs(details.Birthdate).format('MM/DD/YYYY')
          : null,
      Gender: details.Gender,
      Age: details.Age ?? null,
      PreferredName: details.PreferredName ?? null,
    };
    return objtoReturn;
  } else {
    return {
      ...personAlertObj,
      PrimaryPhone:
        personAlertObj && personAlertObj.PrimaryPhone !== undefined
          ? ensureCountryId(personAlertObj.PrimaryPhone || {}, usCountryId)
          : null,
      SecondaryPhone:
        personAlertObj && personAlertObj?.SecondaryPhone !== undefined
          ? ensureCountryId(personAlertObj.SecondaryPhone || {}, usCountryId)
          : null,
      PrimaryAddress:
        personAlertObj &&
        personAlertObj.PrimaryAddress !== undefined &&
        personAlertObj.PrimaryAddress !== null &&
        Object.keys(personAlertObj.PrimaryAddress).length !== 0
          ? {
              ...personAlertObj.PrimaryAddress,
              CountryId:
                personAlertObj.PrimaryAddress?.CountryId === -1
                  ? null
                  : personAlertObj.PrimaryAddress?.CountryId,
              StateProvinceId:
                personAlertObj.PrimaryAddress?.StateProvinceId === -1
                  ? null
                  : personAlertObj.PrimaryAddress?.StateProvinceId,
            }
          : null,
      Birthdate:
        personAlertObj &&
        personAlertObj.Birthdate !== '' &&
        personAlertObj.Birthdate !== undefined &&
        personAlertObj.Birthdate !== null
          ? dayjs(personAlertObj.Birthdate).format('MM/DD/YYYY')
          : null,
      Age:
        personAlertObj && personAlertObj.Age !== '' ? personAlertObj.Age : null,
      PreferredName:
        personAlertObj?.PreferredName !== null &&
        personAlertObj?.PreferredName !== undefined &&
        personAlertObj?.PreferredName !== ''
          ? personAlertObj?.PreferredName
          : null,
    };
  }
}

// to ensure CountryId amd PhoneType id is set if it's missing
const ensureCountryId = (phoneObj: any, usCountryId: any) => {
  return {
    ...phoneObj,
    CountryId: phoneObj?.CountryId ?? usCountryId,
    PhoneTypeId: phoneObj?.PhoneTypeId ?? 1,
    PhoneType: phoneObj?.PhoneType ?? null,
  };
};

function create_UUID() {
  let dt = new Date().getTime();
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (c) {
      let r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    },
  );
  return uuid;
}

// to get the payload for PersonAlertLimiter
function getPersonAlertLimiterValues(
  optionsByAccount: Record<number, Array<any>> | undefined,
) {
  if (!optionsByAccount || typeof optionsByAccount !== 'object') return [];

  return Object.entries(optionsByAccount).flatMap(
    ([accountId, selectedOptions]) => {
      if (!Array.isArray(selectedOptions) || selectedOptions.length === 0)
        return [];

      // Filter out select all
      const filteredOptions = selectedOptions.filter(
        option => option?.value !== 0,
      );

      return filteredOptions.map(option => ({
        PersonAlertId: 0,
        Id: 0,
        AccountCategoryLimitingValueId: option?.value ?? null,
      }));
    },
  );
}
